// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gray{color:#292727}.undo-overlay{position:fixed;bottom:0;left:0;right:0;display:flex;justify-content:center}\n", ""]);
// Exports
module.exports = exports;
